import { IApiActionResult } from "src/~api/ApiActionResult";
import { getApiActionResult, fetchPost } from "src/~api/ApiHelper";

import {
    GET_CONTACTS_FIELD_API_ROUTE,
    GET_ALL_TRIGGERS_BY_TOPIC_EXTERNAL_ID_API_ROUTE
} from "./apiRoutes";

import { ISearchingTag } from "src/app/shared/components/tag-searching-input/~types/models/SearchingTag";
import { toApiSearchingTags } from "src/app/shared/helpers/api-body-helper/searchInputHelper";
import { ContactField } from "../~types/models/ConctactField";
import { TopicPairStatus } from "../../../../nlp/~store/models/enums/TopicPairStatus";

export const getContactsFieldByTagsAsync = async (count: number, searchString: string, searchingTags: ISearchingTag[], field: ContactField): Promise<IApiActionResult<string[]>> => {
    const fetchPromise = fetchPost(GET_CONTACTS_FIELD_API_ROUTE, {
        body: JSON.stringify({
            count,
            searchString,
            tags: toApiSearchingTags(searchingTags),
            field
        })
    });
    return await getApiActionResult(fetchPromise, true);
};

export const getAllTriggersByTopicExternalIdAsync = async (count: number, topicExternalId: string, searchString: string, topicPairStatus: TopicPairStatus | null): Promise<IApiActionResult<string[]>> => {    
    const fetchPromise = fetchPost(GET_ALL_TRIGGERS_BY_TOPIC_EXTERNAL_ID_API_ROUTE, {
        body: JSON.stringify({
            count,
            topicExternalId,
            searchString,
            topicPairStatus
        })
    });
    return await getApiActionResult(fetchPromise, true);
};